/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyRefundPayment } from 'app/shared/model/pharmacy-refund-payment.model';
import { IPharmacyBillPayment } from 'app/shared/model/pharmacy-bill-payment.model';
import { IPharmacySaleCredit } from 'app/shared/model/pharmacy-sale-credit.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacyConsumer } from 'app/shared/model/pharmacy-consumer.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { TransactionType } from 'app/shared/model/enumerations/transaction-type.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacySaleCreditPaymentTracker {
  id?: string;
  settledAmount?: number;
  transactionType?: keyof typeof TransactionType;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  active?: boolean;
  cursor?: number;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  refundPayment?: IPharmacyRefundPayment | null;
  salePayment?: IPharmacyBillPayment | null;
  parentCredit?: IPharmacySaleCredit | null;
  pharmacy?: IPharmacy | null;
  payedCredit?: IPharmacySaleCredit | null;
  consumer?: IPharmacyConsumer | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IPharmacySaleCreditPaymentTracker> = {
  active: false,
};
